/**
 * What each bot step says in the chat: the model's tool names (catalog slugs with dots as
 * underscores, specialists as `bot_<slug>`) as plain words, while running and once done.
 */
const LABELS: Record<string, readonly [running: string, done: string]> = {
  portal_countApplications: ["Counting applications by stage", "Counted applications by stage"],
  portal_listRecentApplications: ["Listing recent applications", "Listed recent applications"],
  portal_listApplications: ["Searching applications", "Searched applications"],
  portal_getApplication: ["Opening the application", "Opened the application"],
  portal_listApplicationHistory: ["Reading the stage history", "Read the stage history"],
  portal_listApplicationDocuments: ["Checking documents", "Checked documents"],
  portal_listApplicationNotes: ["Reading application notes", "Read application notes"],
  portal_getApplicationStats: ["Pulling volume trends", "Pulled volume trends"],
  portal_listMerchants: ["Searching merchants", "Searched merchants"],
  portal_getMerchant: ["Opening the merchant", "Opened the merchant"],
  portal_listMerchantNotes: ["Reading merchant notes", "Read merchant notes"],
  portal_listIdleMerchants: ["Checking idle merchants", "Checked idle merchants"],
  portal_listTickets: ["Searching tickets", "Searched tickets"],
  portal_getTicket: ["Opening the ticket", "Opened the ticket"],
  portal_getTicketMetrics: ["Pulling ticket metrics", "Pulled ticket metrics"],
  portal_listSubmissions: ["Checking processor submissions", "Checked processor submissions"],
  portal_listStuckApplications: ["Checking stuck applications", "Checked stuck applications"],
  portal_getFunnel: ["Building the stage funnel", "Built the stage funnel"],
  portal_getStageMovements: ["Counting stage movements", "Counted stage movements"],
  portal_getStageVelocity: ["Measuring time per stage", "Measured time per stage"],
  portal_getBottlenecks: ["Checking bottlenecks", "Checked bottlenecks"],
  portal_getStatusRollup: ["Counting new applications per day", "Counted new applications per day"],
  "bot_portal-pipeline": ["Asking the pipeline specialist", "Asked the pipeline specialist"],
  "bot_portal-merchants": ["Asking the merchants specialist", "Asked the merchants specialist"],
  "bot_portal-support": ["Asking the support specialist", "Asked the support specialist"],
  "bot_portal-ops": ["Asking the operations specialist", "Asked the operations specialist"],
  knowledge_search: ["Searching the knowledge base", "Searched the knowledge base"],
};

/** An unknown tool's name as words: `portal_listThings` → "List things". */
function humanize(toolName: string): string {
  const words = toolName
    .replace(/^(portal|bot)_/, "")
    .replace(/[-_]+/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .toLowerCase()
    .trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function toolLabel(toolName: string, running: boolean): string {
  const pair = LABELS[toolName];
  if (!pair) return humanize(toolName);
  return running ? pair[0] : pair[1];
}
